module.exports = __webpack_public_path__ + "img/page_bg_establishment.dd0a90ed.png";